import React from 'react';
import './paymentCond.scss';

import {handleAuthError} from '../../globals';
import { createStore } from 'devextreme-aspnet-data';
import DataGrid, {
  Column,
  Lookup,
  Editing,
  Selection,
  SearchPanel
} from 'devextreme-react/data-grid';

import { useState, useEffect } from "react";

const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/CondizioniPagamento'

const remoteDataSource = createStore({
    key: 'id',
    loadUrl: serviceUrl + '/GetAction',
    insertUrl: serviceUrl + '/InsertAction',
    updateUrl:serviceUrl + '/UpdateAction',
    deleteUrl: serviceUrl + '/DeleteAction',

    errorHandler: (error) => {
      handleAuthError(error);
    }
});

export default function PaymentCond() {

  const [tdi, setTDI] = useState({});
  const [tdp, setTDP] = useState({});

  useEffect(() => {

    const newServiceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/TipoDataInizio';
    var newUrl =  newServiceUrl + "/GetAction" ;

    const newServiceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/TipoDataPianificazione';
    var newUrl2 =  newServiceUrl2 + "/GetAction" ;

    const fetchData = async () => {
      try {
        
        const response = await fetch(newUrl);
        const json = await response.json();
        //console.log("Load TipoDataInizio" +json);
        setTDI(json);

        const response2 = await fetch(newUrl2);
        const json2 = await response2.json();
        //console.log("Load TipoDataPianficazione" +json2);
        setTDP(json2);


      } catch (error) {
        console.log("error", error);
      }
    };   

    fetchData();
  }, []);

return (
  <React.Fragment>
    <h2 className={'content-block'}>Condizioni di Pagamento</h2>
    <div className={'content-block'}>
      <div className={'dx-card responsive-paddings'}>
        
      <DataGrid
        dataSource={remoteDataSource}
        focusedRowEnabled={true}
        >
         <SearchPanel visible={true} width={240} placeholder="Cerca..." />
        <Selection mode="single" />
        <Editing
          mode="row"
          useIcons={true}
          allowAdding={true}
          allowDeleting={true}
          allowUpdating={true}     
        />
        <Column dataField="id" visible={false}/>
        <Column dataField="codice" width={160}/>
        <Column dataField="descrizione" width={460}/>
        <Column dataField="tipoDataPianificazioneId" caption="Tipo Data Pianificazione" width={200}>
          <Lookup dataSource={tdp} valueExpr="id" displayExpr="descrizione" />
        </Column>
        <Column dataField="tipoDataInizioId" caption="Tipo Data Inizio" width={200}>
          <Lookup dataSource={tdi} valueExpr="id" displayExpr="descrizione" />
        </Column>
        <Column dataField="giorniFrequenza" />
        <Column dataField="rate" />
      </DataGrid>  

      </div>
    </div>
  </React.Fragment>
)};
